export default "__VITE_ASSET__CmUMui8Z__"